var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.dataLoaded
    ? _c("div", [
        _vm.reviews && _vm.reviews.ratings.length && _vm.reviews.status == "ok"
          ? _c(
              "ul",
              { class: { loading: _vm.loading } },
              _vm._l(_vm.reviews.ratings, function (item, index) {
                return _c("li", [
                  _c(
                    "div",
                    [
                      item.rater != ""
                        ? _c(
                            "div",
                            { staticClass: "name" },
                            [
                              _vm.userIcon
                                ? _c("i", {
                                    staticClass: "fa fa-user-circle-o",
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              item.rater.split(" ").length >= 2
                                ? [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("truncate")(
                                          item.rater.split(" ")[0],
                                          30,
                                          "..."
                                        )
                                      ) +
                                        " " +
                                        _vm._s(
                                          item.rater.split(" ")[1].slice(0, 1)
                                        ) +
                                        "."
                                    ),
                                  ]
                                : [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("truncate")(
                                          item.rater,
                                          30,
                                          "..."
                                        )
                                      )
                                    ),
                                  ],
                            ],
                            2
                          )
                        : _c("div", { staticClass: "name" }, [
                            _vm.userIcon
                              ? _c("i", { staticClass: "fa fa-user-circle-o" })
                              : _vm._e(),
                            _vm._v(
                              _vm._s(
                                _vm.$translate("reviewWidget::Template.guest")
                              )
                            ),
                          ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "date" }, [
                        _vm._v(
                          "\n                    " +
                            _vm._s(item.date.split("-")[2]) +
                            "." +
                            _vm._s(item.date.split("-")[1]) +
                            "." +
                            _vm._s(item.date.split("-")[0]) +
                            "\n                "
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "stars" },
                        [
                          _vm._l(item.stars * 1, function (index) {
                            return [_c("i", { staticClass: "fa fa-star" })]
                          }),
                          _vm._v(" "),
                          _vm._l(5 - item.stars * 1, function (index) {
                            return [_c("i", { staticClass: "fa fa-star grey" })]
                          }),
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _vm.limit &&
                      _vm.limitNumber &&
                      item.comment.replaceAll("????", "").trim().split(" ")
                        .length > _vm.limitNumber
                        ? _c(
                            "div",
                            { staticClass: "comment" },
                            [
                              _vm._l(
                                item.comment
                                  .replaceAll("????", "")
                                  .trim()
                                  .split(" "),
                                function (comment, index) {
                                  return index < _vm.limitNumber
                                    ? [_vm._v(_vm._s(comment) + " ")]
                                    : _vm._e()
                                }
                              ),
                              _c("span", { staticClass: "ppp" }, [
                                _vm._v("..."),
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "limiter" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$translate(
                                      "reviewWidget::Template.limiter"
                                    )
                                  )
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "show-more" },
                                [
                                  _vm._l(
                                    item.comment
                                      .replaceAll("????", "")
                                      .trim()
                                      .split(" "),
                                    function (comment, index) {
                                      return index >= _vm.limitNumber
                                        ? [_vm._v(_vm._s(comment) + " ")]
                                        : _vm._e()
                                    }
                                  ),
                                ],
                                2
                              ),
                            ],
                            2
                          )
                        : _c(
                            "div",
                            { staticClass: "comment" },
                            [
                              item.comment == ""
                                ? [
                                    _vm._v(
                                      "\n                        " +
                                        _vm._s(item.title) +
                                        "\n                    "
                                    ),
                                  ]
                                : [
                                    _vm._v(
                                      "\n                        " +
                                        _vm._s(
                                          item.comment
                                            .replaceAll("????", "")
                                            .trim()
                                        ) +
                                        "\n                    "
                                    ),
                                  ],
                            ],
                            2
                          ),
                      _vm._v(" "),
                      _vm._l(_vm.variations.documents, function (image) {
                        return _vm.variations.total > 0 && !_vm.noImage
                          ? [
                              image.id == item.relationId
                                ? [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "img",
                                        on: {
                                          click: function ($event) {
                                            return _vm.directToItem(
                                              "/" +
                                                image.data.texts.urlPath +
                                                "_" +
                                                image.data.item.id +
                                                "_" +
                                                image.id
                                            )
                                          },
                                        },
                                      },
                                      [
                                        image.data.images.variation.length > 0
                                          ? _c("lazy-img", {
                                              attrs: {
                                                "image-url":
                                                  image.data.images.variation[0]
                                                    .urlPreview,
                                                alt: image.data.texts.name1,
                                              },
                                            })
                                          : _c("lazy-img", {
                                              attrs: {
                                                "image-url":
                                                  image.data.images.all[0]
                                                    .urlPreview,
                                                alt: image.data.texts.name1,
                                              },
                                            }),
                                        _vm._v(" "),
                                        _c("span", { staticClass: "date" }, [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("truncate")(
                                                image.data.texts.name1,
                                                60,
                                                "..."
                                              )
                                            )
                                          ),
                                        ]),
                                      ],
                                      1
                                    ),
                                  ]
                                : _vm._e(),
                            ]
                          : _vm._e()
                      }),
                    ],
                    2
                  ),
                ])
              }),
              0
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.reviews && _vm.reviews.totalPages >= 2
          ? _c(
              "ol",
              { staticClass: "pag" },
              [
                _vm.reviews.pageNo <= 2
                  ? [
                      _vm.reviews.pageNo == 1
                        ? [
                            _c(
                              "li",
                              {
                                staticClass: "active",
                                on: {
                                  click: function ($event) {
                                    return _vm.loadReviews(1)
                                  },
                                },
                              },
                              [_vm._v("1")]
                            ),
                            _vm._v(" "),
                            _c(
                              "li",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.loadReviews(2)
                                  },
                                },
                              },
                              [_vm._v("2")]
                            ),
                            _vm._v(" "),
                            _vm.reviews.totalPages >= 3
                              ? _c(
                                  "li",
                                  {
                                    on: {
                                      click: function ($event) {
                                        return _vm.loadReviews(3)
                                      },
                                    },
                                  },
                                  [_vm._v("3")]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "li",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.loadReviews(2)
                                  },
                                },
                              },
                              [
                                _c("i", {
                                  staticClass: "fa fa-angle-right",
                                  attrs: { "aria-hidden": "true" },
                                }),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "li",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.loadReviews(
                                      _vm.reviews.totalPages
                                    )
                                  },
                                },
                              },
                              [
                                _c("i", {
                                  staticClass: "fa fa-angle-right",
                                  attrs: { "aria-hidden": "true" },
                                }),
                                _c("i", {
                                  staticClass: "fa fa-angle-right",
                                  attrs: { "aria-hidden": "true" },
                                }),
                              ]
                            ),
                          ]
                        : [
                            _c(
                              "li",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.loadReviews(1)
                                  },
                                },
                              },
                              [
                                _c("i", {
                                  staticClass: "fa fa-angle-left",
                                  attrs: { "aria-hidden": "true" },
                                }),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "li",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.loadReviews(1)
                                  },
                                },
                              },
                              [_vm._v("1")]
                            ),
                            _vm._v(" "),
                            _c(
                              "li",
                              {
                                staticClass: "active",
                                on: {
                                  click: function ($event) {
                                    return _vm.loadReviews(2)
                                  },
                                },
                              },
                              [_vm._v("2")]
                            ),
                            _vm._v(" "),
                            _vm.reviews.totalPages >= 3
                              ? _c(
                                  "li",
                                  {
                                    on: {
                                      click: function ($event) {
                                        return _vm.loadReviews(3)
                                      },
                                    },
                                  },
                                  [_vm._v("3")]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.reviews.totalPages >= 3
                              ? _c(
                                  "li",
                                  {
                                    on: {
                                      click: function ($event) {
                                        return _vm.loadReviews(3)
                                      },
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fa fa-angle-right",
                                      attrs: { "aria-hidden": "true" },
                                    }),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.reviews.totalPages != _vm.reviews.pageNo
                              ? _c(
                                  "li",
                                  {
                                    on: {
                                      click: function ($event) {
                                        return _vm.loadReviews(
                                          _vm.reviews.totalPages
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fa fa-angle-right",
                                      attrs: { "aria-hidden": "true" },
                                    }),
                                    _c("i", {
                                      staticClass: "fa fa-angle-right",
                                      attrs: { "aria-hidden": "true" },
                                    }),
                                  ]
                                )
                              : _vm._e(),
                          ],
                    ]
                  : _vm.reviews.totalPages == _vm.reviews.pageNo ||
                    _vm.reviews.totalPages - 1 == _vm.reviews.pageNo
                  ? [
                      _vm.reviews.totalPages == _vm.reviews.pageNo
                        ? [
                            _c(
                              "li",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.loadReviews(1)
                                  },
                                },
                              },
                              [
                                _c("i", {
                                  staticClass: "fa fa-angle-left",
                                  attrs: { "aria-hidden": "true" },
                                }),
                                _c("i", {
                                  staticClass: "fa fa-angle-left",
                                  attrs: { "aria-hidden": "true" },
                                }),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "li",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.loadReviews(
                                      _vm.reviews.pageNo - 1
                                    )
                                  },
                                },
                              },
                              [
                                _c("i", {
                                  staticClass: "fa fa-angle-left",
                                  attrs: { "aria-hidden": "true" },
                                }),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "li",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.loadReviews(
                                      _vm.reviews.pageNo - 2
                                    )
                                  },
                                },
                              },
                              [_vm._v(_vm._s(_vm.reviews.pageNo - 2))]
                            ),
                            _vm._v(" "),
                            _c(
                              "li",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.loadReviews(
                                      _vm.reviews.pageNo - 1
                                    )
                                  },
                                },
                              },
                              [_vm._v(_vm._s(_vm.reviews.pageNo - 1))]
                            ),
                            _vm._v(" "),
                            _c("li", { staticClass: "active" }, [
                              _vm._v(_vm._s(_vm.reviews.pageNo)),
                            ]),
                          ]
                        : [
                            _c(
                              "li",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.loadReviews(1)
                                  },
                                },
                              },
                              [
                                _c("i", {
                                  staticClass: "fa fa-angle-left",
                                  attrs: { "aria-hidden": "true" },
                                }),
                                _c("i", {
                                  staticClass: "fa fa-angle-left",
                                  attrs: { "aria-hidden": "true" },
                                }),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "li",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.loadReviews(
                                      _vm.reviews.pageNo - 1
                                    )
                                  },
                                },
                              },
                              [
                                _c("i", {
                                  staticClass: "fa fa-angle-left",
                                  attrs: { "aria-hidden": "true" },
                                }),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "li",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.loadReviews(
                                      _vm.reviews.pageNo - 1
                                    )
                                  },
                                },
                              },
                              [_vm._v(_vm._s(_vm.reviews.pageNo - 1))]
                            ),
                            _vm._v(" "),
                            _c("li", { staticClass: "active" }, [
                              _vm._v(_vm._s(_vm.reviews.pageNo)),
                            ]),
                            _vm._v(" "),
                            _c(
                              "li",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.loadReviews(
                                      _vm.reviews.pageNo + 1
                                    )
                                  },
                                },
                              },
                              [_vm._v(_vm._s(_vm.reviews.pageNo + 1))]
                            ),
                            _vm._v(" "),
                            _c(
                              "li",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.loadReviews(
                                      _vm.reviews.pageNo + 1
                                    )
                                  },
                                },
                              },
                              [
                                _c("i", {
                                  staticClass: "fa fa-angle-right",
                                  attrs: { "aria-hidden": "true" },
                                }),
                              ]
                            ),
                          ],
                    ]
                  : [
                      _c(
                        "li",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.loadReviews(1)
                            },
                          },
                        },
                        [
                          _c("i", {
                            staticClass: "fa fa-angle-left",
                            attrs: { "aria-hidden": "true" },
                          }),
                          _c("i", {
                            staticClass: "fa fa-angle-left",
                            attrs: { "aria-hidden": "true" },
                          }),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "li",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.loadReviews(_vm.reviews.pageNo - 1)
                            },
                          },
                        },
                        [
                          _c("i", {
                            staticClass: "fa fa-angle-left",
                            attrs: { "aria-hidden": "true" },
                          }),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "li",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.loadReviews(_vm.reviews.pageNo - 1)
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.reviews.pageNo - 1))]
                      ),
                      _vm._v(" "),
                      _c(
                        "li",
                        {
                          staticClass: "active",
                          on: {
                            click: function ($event) {
                              return _vm.loadReviews(_vm.reviews.pageNo)
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.reviews.pageNo))]
                      ),
                      _vm._v(" "),
                      _c(
                        "li",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.loadReviews(_vm.reviews.pageNo + 1)
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.reviews.pageNo + 1))]
                      ),
                      _vm._v(" "),
                      _c(
                        "li",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.loadReviews(_vm.reviews.pageNo + 1)
                            },
                          },
                        },
                        [
                          _c("i", {
                            staticClass: "fa fa-angle-right",
                            attrs: { "aria-hidden": "true" },
                          }),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "li",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.loadReviews(_vm.reviews.totalPages)
                            },
                          },
                        },
                        [
                          _c("i", {
                            staticClass: "fa fa-angle-right",
                            attrs: { "aria-hidden": "true" },
                          }),
                          _c("i", {
                            staticClass: "fa fa-angle-right",
                            attrs: { "aria-hidden": "true" },
                          }),
                        ]
                      ),
                    ],
              ],
              2
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.reviews && _vm.reviews.ratings && _vm.reviews.totalPages >= 2
          ? _c("div", { staticClass: "page" }, [
              _vm._v(
                _vm._s(_vm.$translate("reviewWidget::Template.page")) +
                  " " +
                  _vm._s(_vm.reviews.pageNo) +
                  " " +
                  _vm._s(_vm.$translate("reviewWidget::Template.of")) +
                  " " +
                  _vm._s(_vm.reviews.totalPages)
              ),
            ])
          : _vm._e(),
      ])
    : _c("div", [
        _c(
          "ul",
          { staticClass: "pholder" },
          _vm._l(12, function (n) {
            return _c("li", [
              _c("div", [
                _c("div", { staticClass: "name" }, [
                  _vm.userIcon
                    ? _c("i", { staticClass: "fa fa-user-circle-o" })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("span", { staticClass: "a-bg" }, [_vm._v("   ")]),
                ]),
                _vm._v(" "),
                _vm._m(0, true),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "stars" },
                  [
                    _vm._l(5, function (n) {
                      return [_c("i", { staticClass: "fa fa-star grey" })]
                    }),
                  ],
                  2
                ),
                _vm._v(" "),
                _vm._m(1, true),
              ]),
            ])
          }),
          0
        ),
      ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "date" }, [
      _c("span", { staticClass: "a-bg" }, [_vm._v(" ")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "comment" }, [
      _c("span", { staticClass: "a-bg" }, [_vm._v(" ")]),
      _vm._v(" "),
      _c("span", { staticClass: "a-bg" }, [_vm._v(" ")]),
      _vm._v(" "),
      _c("span", { staticClass: "a-bg" }, [_vm._v(" ")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }